import React from "react";
import './App.css';
import Thermophysical from './Thermophysical';

function App() {
  return (
    <>
      <div className="App">
      <h1>Liquidus Temperature and Thermodynamic Property Predictor for Al<sub>2</sub>O<sub>3</sub>-SiO<sub>2</sub>-CaO-MgO Slag System</h1>
      <Thermophysical />
      </div>
    </>
    
  );
}

export default App;
